import { SVGProps } from 'react';

const SvgUsers = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M12 21.23a9.23 9.23 0 1 0 0-18.46 9.23 9.23 0 0 0 0 18.46Zm0 1.847c6.118 0 11.077-4.96 11.077-11.077C23.077 5.882 18.117.923 12 .923 5.882.923.923 5.883.923 12c0 6.118 4.96 11.077 11.077 11.077Z"
      clipRule="evenodd"
    />
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M4.75 15.155a3.608 3.608 0 0 1 2.55-1.057h5.371a3.608 3.608 0 0 1 3.609 3.608v3.131a.923.923 0 0 1-1.846 0v-3.13a1.762 1.762 0 0 0-1.763-1.763h-5.37a1.762 1.762 0 0 0-1.763 1.762v.518a.923.923 0 0 1-1.846 0v-.518c0-.957.38-1.874 1.057-2.551ZM9.986 7.888a1.762 1.762 0 1 0 0 3.525 1.762 1.762 0 0 0 0-3.525ZM6.378 9.65a3.608 3.608 0 1 1 7.216 0 3.608 3.608 0 0 1-7.216 0ZM16.477 14.877a.923.923 0 0 1 1.124-.663 3.609 3.609 0 0 1 2.707 3.492v.84a.923.923 0 0 1-1.846 0v-.84a1.762 1.762 0 0 0-1.322-1.704.923.923 0 0 1-.663-1.124ZM13.791 6.823a.923.923 0 0 1 1.123-.665 3.608 3.608 0 0 1 0 6.991.923.923 0 1 1-.458-1.788 1.762 1.762 0 0 0 0-3.414.923.923 0 0 1-.665-1.124Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgUsers;
